const TEN = 10;

function getFormater(decimal: number, currency?: string) {
	return new Intl.NumberFormat(window.navigator.language ?? "en-US", {
		style: currency ? "currency" : "decimal",
		minimumFractionDigits: decimal,
		maximumFractionDigits: decimal,
		...(currency ? { currency, currencyDisplay: "code" } : {}),
	});
}

function buildNumber(partedNumber: Intl.NumberFormatPart[]) {
	return partedNumber.reduce<BuildNumber>(
		(acc, part) => {
			if (part.type === "currency") {
				acc.currency = part.value;
			} else if (part.type === "integer" || part.type === "group") {
				acc.integer += part.value;
			} else if (part.type === "fraction" || part.type === "decimal") {
				acc.fraction += part.value;
			}
			return acc;
		},
		{ integer: "", fraction: "", currency: null },
	);
}

type BuildNumber = {
	currency: string | null;
	integer: string;
	fraction: string;
};

type NumberFormaterProps = {
	value: number;
	decimal?: number;
};

type CurrencyFormaterProps = NumberFormaterProps & {
	currency?: string;
	type?: "cents" | "currency";
};

export function getFormattedCurrency({ value, currency = "EUR", type = "cents", decimal = 2 }: CurrencyFormaterProps): BuildNumber {
	return buildNumber(getFormater(decimal, currency).formatToParts(type === "cents" ? value / TEN ** decimal : value));
}

export function getFormattedNumber({ value, decimal = 0 }: NumberFormaterProps): BuildNumber {
	return buildNumber(getFormater(decimal).formatToParts(value));
}

export function getFormattedNumberSimple({ value, decimal = 0 }: NumberFormaterProps): string {
	return getFormater(decimal).format(value);
}

export const formatCurrencyWithNumberToSymbolWithNumber = (value: string | number, currency: string) => {
	if (!value && value !== 0) return "";
	if (typeof value === "string") value = parseFloat(value);

	try {
		const formatter = new Intl.NumberFormat("en-US", {
			style: "currency",
			currency,
			currencyDisplay: "narrowSymbol",
		});
		const parts = formatter.formatToParts(value / 100);
		const currencySymbol = parts.find(part => part.type === "currency")?.value;
		const numberPart = formatter
			.format(value / 100)
			.replace(currencySymbol || "", "")
			.trim();
		return `${numberPart}${currencySymbol}`;
	} catch {
		return `${Number(value) / 100}${currency}`;
	}
};
